import { Route, Routes } from "react-router-dom";
import { Home } from "./views/home/home";
import { Login } from "./views/login/login";
import { StoreContext } from "./context/store.context";
import { Store } from "../shared/types";
import { Register } from "./views/register/register";
import { WrongEmail } from "./views/wrong-email/wrongEmail";
import { Otp } from "./views/otp/otp";
import { OtpKey } from "./views/otp/key";
import { OtpQr } from "./views/otp/qr";
import { Admin } from "./views/admin/admin";
import { Name } from "./views/admin/views/name/name";
import { UserContextProvider } from "./context/user.context";
import { Phone } from "./views/admin/views/phone/phone";
import { Email } from "./views/admin/views/email/email";
import { Password } from "./views/admin/views/password/password";
import { EmailVerified } from "./views/email-verified/emailVerified";
import {
  ForgotPassword,
  ResetPassword,
} from "./views/forgot-password/forgotPassword";

export const App: React.FC<{ store: Store }> = ({ store }) => {
  return (
    <StoreContext.Provider value={store}>
      <UserContextProvider initialUser={store.user}>
        <Routes>
          <Route path="/:app" element={<Home />} />
          <Route path="/:app/logg-inn" element={<Login />} />
          <Route path="/:app/glemt-passord" element={<ForgotPassword />} />
          <Route path="/:app/nytt-passord" element={<ResetPassword />} />
          <Route path="/:app/registrer" element={<Register />} />
          <Route path="/:app/feil-epost" element={<WrongEmail />} />
          <Route path="/:app/epost-verifisert" element={<EmailVerified />} />
          <Route path="/:app/administrer" element={<Admin />} />
          <Route path="/:app/administrer/navn" element={<Name />} />
          <Route path="/:app/administrer/telefonnummer" element={<Phone />} />
          <Route path="/:app/administrer/e-post" element={<Email />} />
          <Route
            path="/:app/administrer/endre-passord"
            element={<Password />}
          />
          <Route path="/:app/administrer/tofaktor" element={<Otp />} />
          <Route
            path="/:app/administrer/tofaktor/nokkel"
            element={<OtpKey />}
          />
          <Route path="/:app/administrer/tofaktor/qr" element={<OtpQr />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </UserContextProvider>
    </StoreContext.Provider>
  );
};
